import script from "./AccountPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountPage.vue?vue&type=script&lang=ts&setup=true"

import "./AccountPage.vue?vue&type=style&index=0&id=c4b150d2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ljy\\Desktop\\workspace\\JIN-SOLUTIONS\\JMON_MES\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4b150d2"]])

export default __exports__